import * as React from 'react';
import * as Header from '../constants/Header';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/settings.css';

interface SettingProps extends React.Props<{}> {
  headerActions: any;
}

class Setting extends React.Component<SettingProps, {}> {
  componentWillMount() {
    document.title = '管理';
    this.props.headerActions.setPage(Header.SETTING);
  }

  render() {
    return (
      <div className="menulist">
        <a className="btnStyleMenu" href="change_password.html">パスワードを変更する</a>
        <a className="btnStyleMenu" href="forgot_password.html">パスワードを忘れた方はこちら</a>
      </div>
    );
  }
}

export default Setting;



// WEBPACK FOOTER //
// ./src/components/Setting.tsx